import { Region } from "./common"

export function toMapkitRegion(region:Region):mapkit.CoordinateRegion {
    return new mapkit.BoundingRegion(region.northLat, region.eastLng, region.southLat, region.westLng).toCoordinateRegion()
}

export function toRegion(region:mapkit.BoundingRegion) {
    return new Region(region.northLatitude, region.southLatitude, region.westLongitude, region.eastLongitude)
}